"use client";

import type { ComponentProps } from "react";
import { SeriesScoreEditor } from "./series-score-editor";

type TableTennisScoreEditorProps = {
  initialData?: Record<string, unknown> | null;
  maxDetailCount?: number;
  onChange: (data: Record<string, unknown>) => void;
} & Pick<
  ComponentProps<typeof SeriesScoreEditor>,
  "team1Label" | "team2Label" | "totalMax"
>;

export function TableTennisScoreEditor({
  initialData,
  onChange,
  maxDetailCount = 9,
  team1Label,
  team2Label,
  totalMax,
}: TableTennisScoreEditorProps) {
  return (
    <SeriesScoreEditor
      matchScoreLabel="Match Score (Games Won)"
      detailsLabel="Game Details (Optional)"
      detailsHint="Enter points per game. Games won are auto-calculated."
      unitSingularLabel="Game"
      matchScoreKeys={{ your: "yourGames", opponent: "opponentGames" }}
      detailsKey="games"
      initialData={initialData}
      maxDetailCount={maxDetailCount}
      detailMaxScore={99}
      team1Label={team1Label}
      team2Label={team2Label}
      totalMax={totalMax}
      onChange={onChange}
    />
  );
}
